import type { RegistryEntry } from "../../shared.ts";
import { CHAT_OPENAI_COMPAT_MODELS } from "../../shared.ts";

export const basetenProvider: RegistryEntry = {
  id: "baseten",
  alias: "baseten",
  format: "openai",
  executor: "default",
  baseUrl: "https://inference.baseten.co/v1/chat/completions",
  authType: "apikey",
  authHeader: "bearer",
  models: CHAT_OPENAI_COMPAT_MODELS.baseten,
};
